import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { BusTerminal } from '@app/entities/bus-company';
import { fetchBusTerminalsSuccessAction } from '@app/store/actions/global.actions';


export interface BusTerminalsState extends EntityState<BusTerminal> { }

function getId(busTerminal: BusTerminal): string {
  return busTerminal.code;
}

export const busTerminalsAdapter: EntityAdapter<BusTerminal> = createEntityAdapter<BusTerminal>({
  selectId: getId
});

export const initialState: BusTerminalsState = busTerminalsAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(fetchBusTerminalsSuccessAction, (state, { busTerminals }) => {
    return busTerminalsAdapter.setAll(busTerminals.map(mapBusTerminals), state);
  })
);

function mapBusTerminals(terminals: string): BusTerminal {
  const terminalAndCity = terminals.split(',').map(section => section.trim());
  const terminalAndCode = terminalAndCity[1].split('(').map(section => section.replace(')', '').trim());
  const code = terminalAndCode[1];
  const city = terminalAndCity[0];
  const name = terminalAndCode[0];
  return { name, code, city };
}

export function busTerminalsReducer(state: BusTerminalsState, action: Action): BusTerminalsState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = busTerminalsAdapter.getSelectors();
